import { render, staticRenderFns } from "./KenyaFlag.vue?vue&type=template&id=2f71c887"
import script from "./KenyaFlag.vue?vue&type=script&lang=js"
export * from "./KenyaFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports